import errors from './errors/index.js';
import translation from './translation/index.js';
const ja = {
    translation,
    errors,
};
export default Object.freeze(ja);
